import { Skeleton, TableCell, TableRow } from "@mui/material"

function TableSkell({ colLength }) {

  return (
    new Array(5)?.fill()?.map((_, i) => (
      <TableRow key={i} sx={{ "td": { borderBottomWidth: i === 4 ? "0" : "1px" } }}>
        {new Array(colLength)?.fill()?.map((_, i) => (
          <TableCell key={i} sx={{ py: 1 }}>
            <Skeleton sx={{ height: "30px" }} />
          </TableCell>
        ))
        }
      </TableRow>
    ))
  )
}

export default TableSkell